import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  RadioGroup,
  Radio,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { useState } from "react";
import { Button, Icon } from "semantic-ui-react";

import styles from "./styles.module.css";
import "./styles.module.css";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { ErrorMessage, Form, Formik } from "formik";
import {
  BusinessStructure,
  ExperienceNigeriaMarket,
  ExperienceSolarSystem,
  LocalPresences,
  NoOfInstallationsDone,
  RelevanceOfCVs,
} from "../../../../../app/models/user";
import { ReactComponent as PlaySvg } from "../../../../../assets/play.svg";

const BorderLinearProgress = styled(LinearProgress)(
  ({ theme, valueBuffer }) => ({
    height: 4,
    borderRadius: 5,
    width: `${valueBuffer}%`,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor:
        theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: theme.palette.mode === "light" ? "#32c36c" : "#308fe8",
    },
    // [`&.${linearProgressClasses.buffer}`]: {
    //   width: valueBuffer,
    // },
  })
);

const FourthStep = (props: any) => {
  const { nextStep, setScoreField, scoreField } = props;

  return (
    <>
      <div style={{ marginTop: "1px" }}>
        <Box sx={{ width: "100%" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              paddingRight: "5%",
              fontSize: "9px",
              fontWeight: "thin",
              color: "#828282",
            }}
          >
            Step 2 of 3
          </div>
          <BorderLinearProgress
            variant="determinate"
            value={66}
            valueBuffer={95}
          />
        </Box>
      </div>
      <div className={styles.header}>Vendor Checklist</div>
      <Formik
        initialValues={{ email: "", password: "", error: null }}
        onSubmit={() => console.log("")}
      >
        {({ handleSubmit, isSubmitting, errors }) => (
          <Form
            className={"ui form " + styles.form}
            onSubmit={handleSubmit}
            autoComplete="off"
          >
            <div>
              <FormControl>
                <FormLabel
                  id="demo-row-radio-buttons-group-label"
                  className={styles.groupHeader}
                >
                  Business Structure e.g. Joint Venture, partnership, Plc, Ltd,
                  Proprietorship etc.
                </FormLabel>
                <RadioGroup
                  // row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="structure"
                  className={styles.justCenterCenter}
                >
                  <FormControlLabel
                    value="Excellent"
                    control={<Radio />}
                    label="Excellent"
                    onChange={() =>
                      setScoreField({
                        ...scoreField,
                        businessStructure: BusinessStructure.Excellence,
                      })
                    }
                  />
                  <FormControlLabel
                    value="Average"
                    control={<Radio />}
                    label="Average"
                    onChange={() =>
                      setScoreField({
                        ...scoreField,
                        businessStructure: BusinessStructure.Average,
                      })
                    }
                  />
                  <FormControlLabel
                    value="Poor"
                    control={<Radio />}
                    label="Poor"
                    onChange={() =>
                      setScoreField({
                        ...scoreField,
                        businessStructure: BusinessStructure.Poor,
                      })
                    }
                  />
                </RadioGroup>
              </FormControl>
            </div>
            <div>
              <FormControl>
                <FormLabel
                  id="demo-row-radio-buttons-group-label"
                  className={styles.groupHeader}
                >
                  Relevance of CVs of Key Engineers, experts, technicians in RE
                  (i.e. local or international qualifications obtained )
                </FormLabel>
                <RadioGroup
                  // row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="size"
                  className={styles.justCenterCenter}
                >
                  <FormControlLabel
                    value="Excellent"
                    control={<Radio />}
                    label="Excellent"
                    onChange={() =>
                      setScoreField({
                        ...scoreField,
                        relevanceOfCVs: RelevanceOfCVs.Excellence,
                      })
                    }
                  />
                  <FormControlLabel
                    value="Average"
                    control={<Radio />}
                    label="Average"
                    onChange={() =>
                      setScoreField({
                        ...scoreField,
                        relevanceOfCVs: RelevanceOfCVs.Average,
                      })
                    }
                  />
                  <FormControlLabel
                    value="Poor"
                    control={<Radio />}
                    label="Poor"
                    onChange={() =>
                      setScoreField({
                        ...scoreField,
                        relevanceOfCVs: RelevanceOfCVs.Poor,
                      })
                    }
                  />
                </RadioGroup>
              </FormControl>
            </div>
            <div>
              <FormControl>
                <FormLabel
                  id="demo-row-radio-buttons-group-label"
                  className={styles.groupHeader}
                >
                  Local presences or ability to quickly mobilize locally in
                  niche market
                </FormLabel>
                <RadioGroup
                  // row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="turnover"
                  className={styles.justCenterCenter}
                >
                  <FormControlLabel
                    value="High"
                    control={<Radio />}
                    label="High"
                    onChange={() =>
                      setScoreField({
                        ...scoreField,
                        localPresences: LocalPresences.High,
                      })
                    }
                  />
                  <FormControlLabel
                    value="Average"
                    control={<Radio />}
                    label="Average"
                    onChange={() =>
                      setScoreField({
                        ...scoreField,
                        localPresences: LocalPresences.Average,
                      })
                    }
                  />
                  <FormControlLabel
                    value="Poor"
                    control={<Radio />}
                    label="Poor"
                    onChange={() =>
                      setScoreField({
                        ...scoreField,
                        localPresences: LocalPresences.Poor,
                      })
                    }
                  />
                </RadioGroup>
              </FormControl>
            </div>
            <div>
              <FormControl>
                <FormLabel
                  id="demo-row-radio-buttons-group-label"
                  className={styles.groupHeader}
                >
                  No of Installations done
                </FormLabel>
                <RadioGroup
                  // row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="percentage"
                  className={styles.justCenterCenter}
                >
                  <FormControlLabel
                    value="Over 500"
                    control={<Radio />}
                    label="Over 500"
                    onChange={() =>
                      setScoreField({
                        ...scoreField,
                        noOfInstallationsDone:
                          NoOfInstallationsDone.OverFiveHundred,
                      })
                    }
                  />
                  <FormControlLabel
                    value="100 - 499"
                    control={<Radio />}
                    label="100 - 499"
                    onChange={() =>
                      setScoreField({
                        ...scoreField,
                        noOfInstallationsDone:
                          NoOfInstallationsDone.HundredToFourHundredNinetyNine,
                      })
                    }
                  />
                  <FormControlLabel
                    value="Less than 100"
                    control={<Radio />}
                    label="Less than 100"
                    onChange={() =>
                      setScoreField({
                        ...scoreField,
                        noOfInstallationsDone:
                          NoOfInstallationsDone.LessThanHundred,
                      })
                    }
                  />
                </RadioGroup>
              </FormControl>
            </div>
            <div>
              <FormControl>
                <FormLabel
                  id="demo-row-radio-buttons-group-label"
                  className={styles.groupHeader}
                >
                  {`Experience in Nigerian Market (No of Projects > 10kw) `}
                </FormLabel>
                <RadioGroup
                  // row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="percentage"
                  className={styles.justCenterCenter}
                >
                  <FormControlLabel
                    value="Over 6"
                    control={<Radio />}
                    label="Over 6"
                    onChange={() =>
                      setScoreField({
                        ...scoreField,
                        experienceNigeriaMarket:
                          ExperienceNigeriaMarket.OverSix,
                      })
                    }
                  />
                  <FormControlLabel
                    value="3 - 5"
                    control={<Radio />}
                    label="3 - 5"
                    onChange={() =>
                      setScoreField({
                        ...scoreField,
                        experienceNigeriaMarket:
                          ExperienceNigeriaMarket.ThreeToFive,
                      })
                    }
                  />
                  <FormControlLabel
                    value="Less than 2"
                    control={<Radio />}
                    label="Less than 2"
                    onChange={() =>
                      setScoreField({
                        ...scoreField,
                        experienceNigeriaMarket:
                          ExperienceNigeriaMarket.LessThanTwo,
                      })
                    }
                  />
                </RadioGroup>
              </FormControl>
            </div>
            <div>
              <FormControl>
                <FormLabel
                  id="demo-row-radio-buttons-group-label"
                  className={styles.groupHeader}
                >
                  Experience with Solar Systems (No. of projects, size and
                  complexity)
                </FormLabel>
                <RadioGroup
                  // row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="percentage"
                  className={styles.justCenterCenter}
                >
                  <FormControlLabel
                    value="Over 5"
                    control={<Radio />}
                    label="Over 5"
                    onChange={() =>
                      setScoreField({
                        ...scoreField,
                        experienceSolarSystem: ExperienceSolarSystem.OverFive,
                      })
                    }
                  />
                  <FormControlLabel
                    value="3 - 5"
                    control={<Radio />}
                    label="3 - 5"
                    onChange={() =>
                      setScoreField({
                        ...scoreField,
                        experienceSolarSystem:
                          ExperienceNigeriaMarket.ThreeToFive,
                      })
                    }
                  />
                  <FormControlLabel
                    value="Less than 2"
                    control={<Radio />}
                    label="Less than 2"
                    onChange={() =>
                      setScoreField({
                        ...scoreField,
                        experienceSolarSystem:
                          ExperienceNigeriaMarket.LessThanTwo,
                      })
                    }
                  />
                </RadioGroup>
              </FormControl>
            </div>
            <div className={styles.next}>
              <Button
                positive
                className={styles.positive}
                onClick={() => nextStep()}
                type="button"
                disabled={
                  !scoreField.businessStructure ||
                  !scoreField.relevanceOfCVs ||
                  !scoreField.localPresences ||
                  !scoreField.noOfInstallationsDone ||
                  !scoreField.experienceNigeriaMarket ||
                  !scoreField.experienceSolarSystem
                }
              >
                <div className={styles.button}>
                  <span>Continue</span>
                  <PlaySvg />
                </div>
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default FourthStep;
